import AbstractHover from './abstractHover';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import SeatInfoBlocks from './seatInfoBlocks';
import ItemDisplay from './itemDisplay';
import Style from './hoverSeat.module.css';

export default class HoverSeat extends AbstractHover {
    renderTitle() {
        if (!this.props.zone) {
            return null;
        }

        return (
            <Trans
                i18nKey="seat_info"
                values={{
                    row: this.props.zone.row,
                    seat: this.props.zone.seat,
                    access: this.props.zone.access
                }}
            >
                Access %access% Row %row% Seat %seat%
            </Trans>
        );
    }

    renderContent() {
        let { zone: seat, contingents, categories, display = 'contingents' } = this.props;

        if (!seat) {
            return null;
        }

        const category = categories?.find(({ uuid }) => uuid === seat.category);
        const contingent = contingents?.find(({ uuid }) => uuid === seat.contingent);

        // Logical inversion: in categories display mode, show assigned contingents
        // to help users understand the relationship between categories and contingents
        const displayedItem = display === 'categories' ? contingent : category;

        if (!displayedItem) {
            return <Trans i18nKey="ticket.availability.no_contingent">No contingent</Trans>;
        }

        return (
            <div className={Style['hover-seat-content']}>
                <SeatInfoBlocks activeBooking={seat.active_booking} bookingState={seat.booking_state} mode="hover" />{' '}
                <ItemDisplay item={displayedItem} type={display === 'categories' ? 'contingent' : 'category'} />
            </div>
        );
    }
}

HoverSeat.propTypes = {
    contingents: PropTypes.array.isRequired,
    categories: PropTypes.array,
    zone: PropTypes.object.isRequired,
    display: PropTypes.oneOf(['contingents', 'categories'])
};
